// Edit and delete for one row, offered only where the server says the row is the caller's
// (`mine`). Not authorisation - the API refuses the rest with 403 regardless - merely not offering
// what would be refused. Shared by the table and the tiles so both say the same thing about a row:
// the table places the two in their own leading columns, the tile has them side by side.

import { Link } from 'react-router';

import Icon from '../ui/Icon.jsx';

export function EditRowAction({ leg, row }) {
  if (!row.mine) return null;
  return (
    <Link className="icon-button quiet" to={`/deliveries/${leg}/${row.delivery_id}/edit`}
          aria-label={`Edit ${row.delivery_id}`} title="Edit">
      <Icon name="pencil" />
    </Link>
  );
}

export function CopyRowAction({ leg, row }) {
  return (
    <Link className="icon-button quiet" to={`/deliveries/${leg}/new?from=${row.delivery_id}`}
          aria-label={`Copy ${row.delivery_id}`} title="Copy">
      <Icon name="copy" />
    </Link>
  );
}

export function DeleteRowAction({ row, onDelete }) {
  if (!row.mine) return null;
  return (
    <button type="button" className="icon-button quiet" onClick={() => onDelete(row.delivery_id)}
            aria-label={`Delete ${row.delivery_id}`} title="Delete">
      <Icon name="trash" />
    </button>
  );
}

export default function RowActions({ leg, row, onDelete }) {
  return (
    <>
      <EditRowAction leg={leg} row={row} />
      <CopyRowAction leg={leg} row={row} />
      <DeleteRowAction row={row} onDelete={onDelete} />
    </>
  );
}
